import { DataRoomActivityOverview, DataRoomActivityWindow } from 'shared';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppQuery } from '../../../../hooks/index';
import { ApiService } from '../../../../services/index';
import { selectedCompanyStorage } from '../../../../storage/company/selected-company.util';
import { keepWithinScope } from './keep-within-scope.util';

/**
 * The Overview tab — 20.1.1.
 *
 * The window is part of the key, so switching it is a cached swap rather than a reload, which is
 * what §2 means by recalculating in place. Nothing here computes a metric: every number on the
 * screen is the one the server defined.
 */
export const useActivityOverview = (window: DataRoomActivityWindow) => {
  const companyId = selectedCompanyStorage(({ companyId: selected }) => selected);

  const { data, isError, isPending, isPlaceholderData, refetch } =
    useAppQuery<DataRoomActivityOverview>({
      queryFn: () =>
        ApiService.get<DataRoomActivityOverview>(
          { endpoint: BackendRoute.DATA_ROOM_ACTIVITY, routePath: ['overview'] },
          { queryParams: { window } },
        ),
      placeholderData: keepWithinScope([QueryKey.GET_DATA_ROOM_ACTIVITY_OVERVIEW, companyId]),
      queryKey: [QueryKey.GET_DATA_ROOM_ACTIVITY_OVERVIEW, companyId, window],
    });

  return { isError, isPending, isReloading: isPlaceholderData, overview: data, retry: refetch };
};
